import React from "react"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { IoLocationOutline } from "react-icons/io5"
import { HiBuildingOffice2 } from "react-icons/hi2"
import { BiTimeFive } from "react-icons/bi"
import { useState, useEffect } from "react"

const JobDetail = ({ props }) => {
    const [isModal, setIsModal] = useState(false)
    const updateModal = () => {
        const width = window.innerWidth
        if (width < 700) {
            setIsModal(true)
        } else {
            setIsModal(false)
        }
    }
    useEffect(() => {
        updateModal()
        window.addEventListener("resize", updateModal)
    }, [])
    return (
        <div>
            {!isModal && (
                <div className="job-description-container">
                    <div className="jobs-title">
                        <h3 style={{ fontSize: "25px" }}>{props.title}</h3>
                        <AiOutlineCloseCircle
                            className="job-description-close"
                            onClick={() => {
                                props.setActiveJob(null)
                            }}
                        />
                    </div>
                    <hr />
                    <p className="flex-row-center" style={{ marginTop: "10px" }}>
                        <IoLocationOutline /> <span> {props.location}</span>
                    </p>
                    <p className="flex-row-center">
                        <HiBuildingOffice2 /> <span> {props.type}</span>
                    </p>
                    {props.duration && (
                        <p className="flex-row-center">
                            <BiTimeFive /> <span> {props.duration}</span>
                        </p>
                    )}
                    <p
                        className="job-description"
                        dangerouslySetInnerHTML={{ __html: props.description }}
                    ></p>
                </div>
            )}
            {isModal && (
                <div className="job-description-modal-container">
                    <div className="job-description-modal-content">
                        <div className="jobs-title">
                            <h3 style={{ fontSize: "25px" }}>{props.title}</h3>
                            <AiOutlineCloseCircle
                                className="job-description-close"
                                onClick={() => {
                                    props.setActiveJob(null)
                                }}
                            />
                        </div>
                        <hr />
                        <p className="flex-row-center" style={{ marginTop: "10px" }}>
                            <IoLocationOutline /> <span> {props.location}</span>
                        </p>
                        <p className="flex-row-center">
                            <HiBuildingOffice2 /> <span> {props.type}</span>
                        </p>
                        {props.duration && (
                            <p className="flex-row-center">
                                <BiTimeFive /> <span> {props.duration}</span>
                            </p>
                        )}
                        <p
                            className="job-description"
                            dangerouslySetInnerHTML={{ __html: props.description }}
                        ></p>
                    </div>
                </div>
            )}
        </div>
    )
}

export default JobDetail
